/*
  PCの慣性スクロール（2026年9月29日 PM指定）

  ホイールで動かしたとき、ページがすっと追いついて静かに止まるようにする。
  参考は kommakomma.is。同じ Lenis（assets/custom lenis.min.js・1.3.11）を
  同じ設定で使うので、効き方はそのまま同じになる。

  実装仕様
  #1 掛けるのは PC（1000px以上・マウスやトラックパッドの操作）だけ。
     SP とタッチは素のスクロールのまま。Lenis の本体もそのときしか読み込まない
  #2 prefers reduced motion では掛けない
  #3 スナップで送るページ（商品詳細・ABOUT のPC）では掛けない。
     Lenis は毎フレーム位置を書き換えるので、CSS の scroll snap と同居できない。
     ページの名前ではなく html に scroll snap type が効いているかで判定する。
     区画のCSSはあとから読み込まれることがあるので、読み込みが終わったときと
     画面幅が境目をまたいだときに判定をやり直す
  #4 ページ内リンクは Lenis に任せない。Lenis の飛び方は飛び先の scroll margin を
     見ないので、追従ヘッダーの下に潜る。素の滑らかな移動（custom layout.css）のまま
     飛ばし、Lenis は動いた位置に追いつくだけにする
  #5 Focal の引き出しは html に overflow hidden を付けてページを止める。
     autoToggle でそれを拾って Lenis も止まる（付属CSSの transition が要る。
     custom layout.css の data c smooth の指定）
  #6 中でスクロールする面（メニュー・横に流れる帯・一覧の枠）は
     allowNestedScroll で素のスクロールに譲る。メニューの面は中身が収まっていて
     スクロールしないときでも裏のページを動かさないよう、data lenis prevent を付けてある
  #7 動いている Lenis を window.cSmoothScroll に置く（止めたら null）。
     ページの側でスクロールを送るときに、同じ慣性の質感で送るため
     （テクノロジーのファーストビューを1回で抜ける送り。assets/custom tech hero.js）
*/
(function () {
  'use strict';

  var PC = '(min-width: 1000px) and (pointer: fine)';
  var REDUCE = '(prefers-reduced-motion: reduce)';
  var ACTIVE = 'data-c-smooth';

  /* kommakomma.is の設定そのまま。lerp は1フレームで目標までの差の何割を詰めるか */
  var OPTIONS = {
    lerp: 0.11,
    wheelMultiplier: 1.05,
    autoRaf: true,
    autoToggle: true,
    allowNestedScroll: true,
    anchors: false
  };

  var script = document.currentScript;
  var src = script && script.getAttribute('data-lenis-src');
  var lenis = null;
  var loading = null;

  function wanted() {
    if (!src || !window.matchMedia) {
      return false;
    }

    if (!window.matchMedia(PC).matches || window.matchMedia(REDUCE).matches) {
      return false;
    }

    var snap = getComputedStyle(document.documentElement).scrollSnapType;

    return !snap || snap === 'none';
  }

  function load() {
    if (window.Lenis) {
      return Promise.resolve();
    }

    if (!loading) {
      loading = new Promise(function (resolve, reject) {
        var tag = document.createElement('script');
        tag.src = src;
        tag.onload = resolve;
        tag.onerror = reject;
        document.head.appendChild(tag);
      });
    }

    return loading;
  }

  function stop() {
    if (!lenis) {
      return;
    }

    lenis.destroy();
    lenis = null;
    window.cSmoothScroll = null;
    document.documentElement.removeAttribute(ACTIVE);
  }

  function sync() {
    if (!wanted()) {
      stop();
      return;
    }

    if (lenis) {
      return;
    }

    load().then(
      function () {
        if (lenis || !wanted()) {
          return;
        }

        document.documentElement.setAttribute(ACTIVE, '');
        lenis = new window.Lenis(OPTIONS);
        window.cSmoothScroll = lenis;
      },
      function () {
        /* 読み込めなければ素のスクロールのまま */
      }
    );
  }

  function watch(query) {
    var mql = window.matchMedia(query);

    if (mql.addEventListener) {
      mql.addEventListener('change', sync);
    }
  }

  if (!window.matchMedia) {
    return;
  }

  sync();
  window.addEventListener('load', sync);
  watch(PC);
  watch(REDUCE);
})();
